export default "__VITE_ASSET__DmVZyT79__"